import PropTypes from 'prop-types'
import styled from 'styled-components'

import IconLink from 'components/Shared/IconLink/Index'
import Tooltip from 'components/Shared/Tooltip/Index'

import colors from 'components/utils/colors'

const StyledWrapper = styled.div`
`

const StyledTitle = styled.span`
  color: ${colors.secondary20};
  font-family: Exo;
  font-size: 14px;
  font-weight: 500;
`

const FilterPanelTitle = ({ title, active, tooltipText, onClick, withoutIcon }) => {
  if (withoutIcon) {
    return (
      <StyledTitle>{title}</StyledTitle>
    )
  }

  return (
    <StyledWrapper>
      <IconLink
        onClick={onClick}
        iconName='icon-filter'
        active={active}
        data-tooltip-content={tooltipText}
        data-tooltip-id='filter-panel-title-tooltip'
        text={title}
      />
      <Tooltip id='filter-panel-title-tooltip' />
    </StyledWrapper>
  )
}

FilterPanelTitle.propTypes = {
  title: PropTypes.string,
  tooltipText: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  withoutIcon: PropTypes.bool,
}

export default FilterPanelTitle
